import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TEAMS_TEAM_LINEUPS_RESTORE_FETCH = 'TEAMS_TEAM_LINEUPS_RESTORE_FETCH'
export const TEAMS_TEAM_LINEUPS_RESTORE_FETCH_CANCELED = 'TEAMS_TEAM_LINEUPS_RESTORE_FETCH_CANCELED'
export const TEAMS_TEAM_LINEUPS_RESTORE_FETCH_ERROR = 'TEAMS_TEAM_LINEUPS_RESTORE_FETCH_ERROR'
export const TEAMS_TEAM_LINEUPS_RESTORE_FETCH_FULFILLED = 'TEAMS_TEAM_LINEUPS_RESTORE_FETCH_FULFILLED'

export const teamLineupsRestoreFetch = (teamId, lineupId) => ({
  payload: { lineupId, teamId },
  type: TEAMS_TEAM_LINEUPS_RESTORE_FETCH,
})

export const teamLineupsRestoreFetchFulfilled = (payload) => ({
  payload,
  type: TEAMS_TEAM_LINEUPS_RESTORE_FETCH_FULFILLED,
})

export const teamLineupsRestoreFetchCanceled = () => ({
  payload: null,
  type: TEAMS_TEAM_LINEUPS_RESTORE_FETCH_CANCELED,
})

export const teamLineupsRestoreFetchError = (payload) => ({
  payload,
  type: TEAMS_TEAM_LINEUPS_RESTORE_FETCH_ERROR,
})

export const teamLineupsRestoreFetchEpic = (action$) =>
  action$.pipe(
    ofType(TEAMS_TEAM_LINEUPS_RESTORE_FETCH),
    mergeMap((action) =>
      epicServerRequest(
        'post',
        `${APP.api_url}/sports/soccer/team/${action.payload.teamId}/lineup/${action.payload.lineupId}`,
        action,
      ).pipe(
        map(epicResponseHandler(teamLineupsRestoreFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TEAMS_TEAM_LINEUPS_RESTORE_FETCH, TEAMS_TEAM_LINEUPS_RESTORE_FETCH_CANCELED))),
        catchError(epicErrorHandler(teamLineupsRestoreFetchError, action)),
      ),
    ),
  )
